import * as React from "react"

function MuchWorse(props) {
  return (
    <svg
      width={19}
      height={13}
      viewBox="0 0 19 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 6h5v9H1V1l5 .5L9 3l5 3.5 3-.5z"
        fill="url(#prefix__paint0_linear)"
      />
      <path
        d="M22 6h-5l-3 .5L9 3 6 1.5 1 1"
        stroke="url(#prefix__paint1_linear)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear"
          x1={11.5}
          y1={1}
          x2={11.5}
          y2={15}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FC4C59" />
          <stop offset={1} stopColor="#E43152" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear"
          x1={11.5}
          y1={1}
          x2={11.5}
          y2={11}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FC4C59" />
          <stop offset={1} stopColor="#E43152" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default MuchWorse
